{
  "countdown_days": {
    "one": "In {count} day",
    "other": "In {count} days"
  },
  "countdown_months": {
    "one": "In about a month",
    "other": "In about {count} months"
  },
  "countdown_today": "Today 🥂",
  "countdown_tomorrow": "Tomorrow!",
  "countdown_weeks": {
    "one": "In a week",
    "other": "In {count} weeks"
  },
  "countdown_years": {
    "one": "In about a year",
    "other": "In about {count} years"
  },
  "create_new_list": "Create New List",
  "feed_added": {
    "one": "{name} put {count} thing on {list}",
    "other": "{name} put {count} things on {list}"
  },
  "feed_added_one": "{name} put {thing} on {list}",
  "feed_follower": "{name} follows you",
  "feed_gifting": "{name}’s gifting {owner} {thing}",
  "feed_gifting_guest": "{name}’s gifting {owner} {thing} (by link)",
  "feed_gifting_you": "Someone’s gifting you {thing}",
  "feed_got": "{name} got {thing}",
  "feed_heading": "What’s new",
  "feed_new": "New",
  "feed_shared": {
    "one": "{name} shared {list} with you · {count} thing on it",
    "other": "{name} shared {list} with you · {count} things on it"
  },
  "gifting_for": "For {name}",
  "gifting_heading": "I’m gifting",
  "gifting_see_all": "See all {count}",
  "greeting": "Hey {name}!",
  "join_failed": "Couldn’t do that. Try again?",
  "join_from": "from {list}",
  "join_heading": "{name} would like to join",
  "join_invite": "Invite {name}",
  "join_invited": "Invited {name}",
  "join_inviting": "Inviting…",
  "join_kicker": "Asking to join",
  "join_none_left": "You’re out of invites for now. More are added automatically, and this waits here till then.",
  "join_not_now": "Not now",
  "join_offline": "You’re offline. Try again once you’re connected.",
  "join_signed_out": "Sign in again to answer this.",
  "join_what": "Inviting uses one of your invites. They’ll follow you and be on {list}, and anything they’re gifting from it becomes theirs in the app.",
  "join_what_no_list": "Inviting uses one of your invites, and they’ll follow you.",
  "page_description": "Cheers to the things you want.",
  "page_title": "TingThings — Cheers to the things you want",
  "recent_activity": "Recent Activity",
  "see_all": "See all",
  "stat_gifts_receiving": "Gifts you're getting",
  "stat_things_on_lists": "Things on your lists",
  "subhead": "Here's what's happening",
  "upnext_empty": "Nothing on it yet",
  "upnext_wanted": {
    "one": "{count} thing on it you still want",
    "other": "{count} things on it you still want"
  },
  "ways_got_it": "Got it",
  "ways_heading": "Three ways to save a thing",
  "ways_heading_web": "Two ways to save a thing",
  "ways_intro": "Whatever you want, it’s one tap from here to save it.",
  "ways_paste": "Paste a link",
  "ways_paste_hint": "Copy a link anywhere, then paste it in",
  "ways_photo": "Take a photo",
  "ways_photo_hint": "Snap it in the shop. Words are optional.",
  "ways_share": "Share it from any app",
  "ways_share_drawing": "A share sheet, with {app} in its row of apps",
  "ways_share_hint": "From Safari, a shop’s app, anywhere",
  "ways_share_more": "Not in the row of apps? Swipe to the end, tap More, and turn {app} on.",
  "ways_share_step1": "Tap Share in the app you’re in.",
  "ways_share_step2": "Tap {app}. That’s it: it’s saved.",
  "your_lists": "Your Lists"
}
